import { tokens } from "../../../theme";
import { Box, Button, Chip, Typography, useTheme } from "@mui/material";
import { releaseStyles } from "../styles";

const MAX_CHIPS = 10;

const patchLabel = (count) => `${count} ${count === 1 ? "patch" : "patches"}`;

// One banner instead of a "No Data" card per patch, then the patch labels themselves so
// the user can see the patches exist and are genuinely empty.
const EmptyState = ({ releases, patchCount, reason, onClear }) => {
  const theme = useTheme();
  const { releaseView } = releaseStyles(tokens(theme.paletteId));
  return (
    <>
      <Box sx={releaseView.emptyBanner}>
        <Box>
          <Typography sx={releaseView.emptyTitle}>
            {patchCount
              ? `No commits in the ${patchLabel(patchCount)} you selected`
              : "No patches in the current selection"}
          </Typography>
          <Typography sx={releaseView.emptyReason}>{reason}</Typography>
        </Box>
        <Button
          variant="outlined"
          size="small"
          sx={releaseView.emptyButton}
          onClick={onClear}
        >
          Clear filters
        </Button>
      </Box>

      {releases.map((release) => {
        const visible = release.patchLabels.slice(0, MAX_CHIPS);
        const hidden = release.patchLabels.length - visible.length;
        return (
          <Box key={release.label} sx={releaseView.emptyRelease}>
            <Typography sx={releaseView.emptyReleaseLabel}>
              {release.label}
            </Typography>
            {visible.map((label, index) => (
              <Chip
                key={`${label}-${index}`}
                size="small"
                label={label}
                sx={releaseView.emptyChip}
              />
            ))}
            {hidden > 0 ? (
              <Typography sx={releaseView.emptyMore}>+{hidden} more</Typography>
            ) : null}
          </Box>
        );
      })}
    </>
  );
};

export default EmptyState;
